export default __webpack_public_path__ + "cover.3a883ba86cbf4be05e32ebb72e027e80.jpg"